































  import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
  import {translate} from "../../services/translation/translation";
  import "./project-gallery-destop.less";
  import BadgesComponent from "@/components/badges/badges.vue";


  @Component({
      components: {
          BadgesComponent
      }
  })
  export default class ProjectGalleryDestop extends Vue {
      @Prop() images;
      @Prop() project;
      private data ={
          'index' :0,
          'visible' :false,
          'images': []
      };
      mounted() {
          if(this.isExist(this.images)){
              this.data.images = this.images;
          }
          let self = this;
          setTimeout(function () {
              self.initGaleryView();
          }, 200);
          $(window).resize(this.initGaleryView)
      }
      getBadgesData() {
          return {
              nominee: this.project!.life_challenge_nominee,
              winner: this.project!.life_challenge_winner,
              total_winner: this.project!.life_challenge_total_winner,
              public_winner: this.project!.life_challenge_public_winner
          };
      }
      trans(key) {
          return translate(key);
      };
      initGaleryView(){
          let self = this;
           $('.project-image-container .widescreen').each(function (i, e) {
              let elem: any= $(e);
              let width: any= elem.width();
              if (elem.hasClass('big'))
                  elem.height(width * 9 / 16);
              else {
                  const big = $('.big');
                  const height = big!.height();
                  elem!.height(height! / 2 - 2.5);
                  }
           });

          $('.project-image-container').addClass('visible');

      }

      imgRatio = 16 / 9;

      loaded(ev) {
          const img = $(ev.target);
          if (img.length) {
          img
              .eq(0)
              .addClass(
              img.get(0).naturalWidth! / img.get(0).naturalHeight! < this.imgRatio
                  ? "narrow"
                  : "wide"
              );
          }
}

      isExist(attributes :any){
          if(attributes == null || typeof attributes == undefined){
              return false;
          } else {
              return true;
          }
      }

      @Emit("showModalGallery")
      onShowModalGallery(index, visible){
      }

  }
